<template>
  <div class="setting-common">
    <el-card class="title-block" shadow="never" :body-style="{padding: '12px'}">
      <span class="fa-stack fa-2x logo">
        <i class="fa fa-circle fa-stack-2x"></i>
        <i class="fa fa-cog fa-stack-1x fa-inverse"></i>
      </span>
      <div class="title">
        <div class="meta">設定</div>
        {{ title }}
      </div>
      <div class="help">
        <el-tooltip effect="dark" content="ヘルプを開く" placement="bottom">
          <el-button icon="el-icon-question" @click="onClickHelp"></el-button>
        </el-tooltip>
      </div>
    </el-card>

    <div class="table-block">
      <div v-if="toolbar" class="header">
        <div class="left">
          <el-input
            placeholder="検索 ... "
            v-model="search"
            class="input-search"
            @keyup.enter.native="onClickSearchButton"
            :clearable="true"
            @clear="handleSearchClearButton"
          >
            <el-button
              slot="append"
              type="primary"
              icon="el-icon-search"
              @click="onClickSearchButton"
            ></el-button>
          </el-input>
        </div>
        <div class="right">
          <el-button-group class="button-group">
            <el-button
              v-if="createButtonEnabled"
              icon="el-icon-plus"
              type="primary"
              @click="onClickNewButton"
            >新規</el-button>
            <el-button
              v-if="deleteButtonEnabled"
              icon="el-icon-delete"
              type="danger"
              @click="onClickDeleteButton"
              :disabled="itemSelected"
            >削除</el-button>
          </el-button-group>
          <el-button-group class="button-group">
            <el-button
              v-if="bulkEditButtonEnabled"
              type="success"
              @click="onClickBulkEnableButton(true)"
              :disabled="itemSelected"
            >有効化</el-button>
            <el-button
              v-if="bulkEditButtonEnabled"
              type="danger"
              @click="onClickBulkEnableButton(false)"
              :disabled="itemSelected"
            >無効化</el-button>
          </el-button-group>
          <imexport-dialog
            v-if="exportUrl || importUrl"
            :title="title"
            :exportUrl="exportUrl"
            :importUrl="importUrl"
            :isCatalog="true"
            :fetch="fetch"
          />
        </div>
      </div>
      <div class="body">
        <slot></slot>
      </div>
    </div>

    <el-dialog
      class="message-box"
      title="削除確認"
      :visible.sync="bulkDeleteDialog.visible"
      :close-on-click-modal="false"
      size="tiny"
      align="left"
      @open="bulkDeleteDialog.isAlert = false; bulkDeleteDialog.errorMessage = ''"
    >
      <span>チェックしている{{ toolbar ? selection.length : 0}}件の{{ deleteDialogTitle.length > 0 ? deleteDialogTitle : title}}を削除してもよいですか？</span>
      <span slot="footer" class="dialog-footer">
        <el-alert
          v-if="bulkDeleteDialog.isAlert"
          :title="bulkDeleteDialog.errorMessage"
          type="error"
          show-icon
          :closable="false"
        ></el-alert>
        <el-button type="danger" @click="handleBulkDelete" :loading="bulkDeleteDialog.loading">はい</el-button>
        <el-button @click="bulkDeleteDialog.visible = false">いいえ</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import ImExport from "@/components/ImExport";

export default {
  name: "Common",
  components: {
    "imexport-dialog": ImExport
  },
  props: {
    title: String,
    deleteDialogTitle: {
      type: String,
      default: ""
    },
    bulkUrl: String,
    canExportImport: {
      type: Boolean,
      default: false
    },
    canExport: {
      type: Boolean,
      default: false
    },
    exportUrl: String,
    importUrl: String,
    toolbar: {
      type: Boolean,
      default: true
    },
    createButtonEnabled: {
      type: Boolean,
      default: true
    },
    deleteButtonEnabled: {
      type: Boolean,
      default: true
    },
    bulkEditButtonEnabled: {
      type: Boolean,
      default: false
    },
    fetch: Function,
    selection: Array,
    deleteCallback: {
      type: Function,
      default: undefined
    },
    helpDialog: Boolean
  },
  data() {
    return {
      search: "",
      bulkDeleteDialog: {
        visible: false,
        loading: false,
        isAlert: false,
        errorMessage: ""
      },
      exportDialog: {
        visible: false,
        testLoading: false,
        loading: false,
        isAlert: false,
        isInfo: false,
        message: "",
        errorMessage: ""
      },
      importDialog: {
        visible: false,
        loading: false,
        errorMessage: ""
      },
      exportForm: {
        email: ""
      },
      exportFormRules: {
        email: [
          { required: true, message: "メールアドレスは必ず入力してください。" },
          { type: "email", message: "メール形式で入力してください。" }
        ]
      }
    };
  },
  computed: {
    itemSelected: function() {
      if (this.toolbar) {
        return this.selection.length === 0;
      }
      return true;
    },
    xsrfHeaders: function() {
      for (let c of document.cookie.split("; ")) {
        if (c.startsWith("csrftoken=")) {
          return { "X-CSRFToken": c.slice(10) };
        }
      }
      return {};
    }
  },
  methods: {
    onClickNewButton: function(event) {
      this.$emit("click-new");
    },
    onClickHelp: function(event) {
      this.$emit("click-help");
    },
    onClickDeleteButton: function(event) {
      if (this.selection.length > 0) {
        this.bulkDeleteDialog.visible = true;
      }
    },
    onClickSearchButton: function(event) {
      this.fetch(this.search);
    },
    handleSearchClearButton: function() {
      this.fetch();
    },
    handleBulkDelete: function() {
      let idlist = this.selection.map(item => {
        return item.id;
      });
      this.bulkDeleteDialog.loading = true;
      this.bulkDeleteDialog.errorMessage = "";
      this.bulkDeleteDialog.isAlert = false;
      axios
        .delete(this.bulkUrl, {
          params: {
            id: JSON.stringify(idlist)
          }
        })
        .then(response => {
          if (this.deleteCallback !== undefined) {
            this.deleteCallback();
          }
          this.bulkDeleteDialog.visible = false;
          this.bulkDeleteDialog.isAlert = false;
          this.bulkDeleteDialog.errorMessage = "";
          this.bulkDeleteDialog.loading = false;
          this.$notify({
            title: "成功",
            message: "削除が完了しました。",
            type: "success",
            duration: 2000
          });
          this.$emit("update:selection", []);
          this.fetch("");
        })
        .catch(error => {
          if (error.response !== undefined) {
            if (error.response.status === 400) {
              let e = error.response.data;
              console.log(e);
              let errorMessage = "";
              if (Array.isArray(e)) {
                errorMessage = e.join(",");
              } else {
                if ("non_field_errors" in e) {
                  errorMessage = e.non_field_errors.join(",");
                } else if ("detail" in e) {
                  errorMessage = e.detail;
                } else {
                  errorMessage = e;
                }
              }
              this.bulkDeleteDialog.visible = false;
              this.bulkDeleteDialog.isAlert = false;
              this.bulkDeleteDialog.errorMessage = "";
              this.bulkDeleteDialog.loading = false;
              this.$notify.error({
                title: "エラー",
                message: errorMessage,
                duration: 2000
              });
              this.$emit("update:selection", []);
              this.fetch("");
            } else {
              this.bulkDeleteDialog.isAlert = true;
              this.bulkDeleteDialog.loading = false;
              this.bulkDeleteDialog.errorMessage =
                "不明なエラーが発生しました。";
            }
          }
        });
    },
    onClickBulkEnableButton: function(enabled) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
      });
      let idlist = this.selection.map(item => {
        return item.id;
      });
      axios
        .put(this.bulkUrl, {
          params: {
            id: JSON.stringify(idlist),
            enabled: enabled
          }
        })
        .then(response => {
          if (this.deleteCallback !== undefined) {
            this.deleteCallback();
          }
          loading.close();
          this.$notify({
            title: "成功",
            message: "変更が完了しました。",
            type: "success",
            duration: 2000
          });
          this.$emit("update:selection", []);
          this.fetch("");
        })
        .catch(error => {
          loading.close();
          if (error.response !== undefined) {
            if (error.response.status === 400) {
              let e = error.response.data;
              console.log(e);
              let errorMessage = "";
              if (Array.isArray(e)) {
                errorMessage = e.join(",");
              } else {
                if ("non_field_errors" in e) {
                  errorMessage = e.non_field_errors.join(",");
                } else if ("detail" in e) {
                  errorMessage = e.detail;
                } else {
                  errorMessage = e;
                }
              }
              this.$notify.error({
                title: "エラー",
                message: errorMessage,
                duration: 2000
              });
              this.$emit("update:selection", []);
              this.fetch("");
            } else {
              this.$notify.error({
                title: "エラー",
                message: "不明なエラーが発生しました。",
                duration: 2000
              });
              this.$emit("update:selection", []);
              this.fetch("");
            }
          }
        });
    }
  }
};
</script>

<style scoped>
/* title */
.logo {
  color: #012c63;
}

.title {
  display: inline-block;
  vertical-align: middle;
  font-size: 18px;
  font-weight: bold;
  margin-left: 12px;
}
.meta {
  color: #666;
  font-size: 14px;
  font-weight: normal;
}

/* table-block */
.table-block {
  margin-top: 16px;
}

.header {
  display: -webkit-flex;
  display: flex;
  border-bottom: 1px solid #e6e6e6;
  align-items: center; /* 縦中央 */
  justify-content: center; /* 縦中央 */
  background-color: #fafafa;
  border: 1px solid #e6e6e6;
}

.header .left {
  -webkit-flex: 1;
  flex: 1;
}

.header .right {
  width: 400px;
  text-align: right;
}

.header,
.body {
  padding: 8px;
}

.right .el-button {
  padding: 8px 14px;
}

.button-group {
  margin-left: 8px;
}

.dropdown-button {
  margin-left: 16px;
}

.dropdown-button .big {
  font-size: 18px;
}

.input-search >>> .el-button {
  border-color: transparent;
  border-radius: 0 2px;
}

.input-search >>> .el-button:hover {
  background-color: #dcdfe6;
}

.help {
  float: right;
  margin-top: 10px;
}
</style>
